<template>
    <header>
          <nav class="navbar navbar-expand-sm d-flex align-items-center">
            <a class="navbar-brand" href="/">
                <img v-if="logoType === 'black'"
            src="../assets/static/images/logo.png"
            alt=""
            srcset="../assets/static/images/logo@2x.png 2x, ../assets/static/images/logo@3x.png 3x"
            class="logo_high_resolution_white cursor-pointer">
                <img v-else
            src="../assets/static/images/logo_small.png"
            alt=""
            srcset="../assets/static/images/logo_small@2x.png 2x, ../assets/static/images/logo_small@3x.png 3x"
            class="logo_high_resolution_white cursor-pointer">
              </a>
            <div id="rightSide" class="right-side" v-show="showButton">
              <ul class="navbar-nav ml-auto align-items-center d-flex flex-row">
                <li class="nav-item">
                  <a v-show="!changePath()" class="nav-link back-link">
                    <span ><router-link :to="{ path: '/' }" style="color: white;cursor: pointer;width: 100%;display: block;">« BACK </router-link></span>
                  </a>
                </li>
                  <slot></slot>
                <li class="nav-item">
                    <button type="button" class="btn btn-dark login-sign-btn" id="sign-btn" v-if="changePath()"><router-link :to="{ path: '/login' }" style="color: white;cursor: pointer;width: 100%;display: block;">LOGIN</router-link></button>
                    <button type="button" class="btn btn-dark login-btn" v-else><router-link :to="{ path: '/sign-up' }" style="color: white;cursor: pointer;width: 100%;display: block;">SIGN UP</router-link></button>
                    <button type="button" class="btn btn-dark login-sign-btn hide" id="save-btn"><a style="color: white;cursor: pointer;width: 100%;display: block;" href="#">SAVE</a></button>
                </li>
              </ul>
            </div>
          </nav>
        </header>
</template>
<script>
export default {
  props: {
    showButton: {
      type: Boolean,
      default: true
    },
    logoType: {
      type: String,
      default: 'black'
    }
  },
  methods: {
    changePath() {
      return this.$router.history.current['path'] !== '/login'
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/RegisterHeader.vue